/**
 * Validates an e-mail address.
 * @param {string} mailAddress The mail address to be verified.
 * @returns {boolean} Returns whether the mail address is valid.
 */
export function validateMail(mailAddress) {
    // Kein Leerzeichen/At-Zeichen vor und nach At, dann Punkt, dann eine Domaine ohne Leerzeichen
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(mailAddress);
}


/**
 * Validates a telephone number.
 * @param {string} phoneNumber The phone number to be verified.
 * @returns {boolean} Returns whether the phone number is valid.
 */
 export function validatePhoneNumber(phoneNumber) {
    // Kein Leerzeichen/At-Zeichen vor und nach At, dann Punkt, dann eine Domaine ohne Leerzeichen
    const regex = /^([+]?)+[0-9\s/-]{6,18}$/;
    return regex.test(phoneNumber);
}

/**
 * Validates a zip code of 4 or 5 digits.
 * @param {string} zipCode The zip code to be verified.
 * @returns {boolean} Returns whether the zip code is valid.
 */
 export function validateZipCode(phoneNumber) {
    const regex = /^[0-9]{4,5}$/;
    return regex.test(phoneNumber);
}

/**
 * Validates a general string.
 * @param {*} term The term to validate.
 * @param {*} minLength Optionally, the minimum length to be required
 * @param {*} maxLength Optionally, the maximum length that must not be exceeded
 * @returns Specifies whether the term is valid or not.
 */
export function validateGeneralTerm(term, minLength = 1, maxLength = 80) {
    if(!term) {
        return false
    }
    
    return !(term.length < minLength || term.length > maxLength)
}


/**
 * Validates a general string.
 * @param {*} term The term to validate.
 * @param {*} minLength Optionally, the minimum length to be required
 * @param {*} maxLength Optionally, the maximum length that must not be exceeded
 * @returns Specifies whether the term is valid or not.
 */
 export function validateSalutation(salutation) {
    return salutation === "Herr" || salutation === "Frau"
}


/**
 * Checks whether a user input is a number and whether it is greater than cero
 * @param {string} input An input string
 * @returns True, if it is a positive number, otherwise false
 */
export function isPositiveNumber(input) {
    const num = Number(input.replace(",", ".")); // transform German commas to decimal commas
    return !isNaN(num) && isFinite(num) && num > 0;
}